import { HitTestLayout } from 'client/app/apps/disco-prototype/components/PlateMapCanvas/common';
import { formatWellCoords } from 'common/types/disco/wellCoords';

// Returns the well ID (e.g. "A1") at the given canvas coordinates, or null if out of bounds.
export function wellIdAtPoint(
  layout: HitTestLayout | null,
  x: number,
  y: number,
): string | null {
  if (!layout) return null;
  const { cellW, cellH, headerOffset, numColumns, numRows } = layout;

  // Check if point falls within the grid area (excluding headers)
  if (
    x < cellW * headerOffset ||
    y < cellH * headerOffset ||
    x > cellW * (headerOffset + numColumns) ||
    y > cellH * (headerOffset + numRows)
  ) {
    return null;
  }

  // Convert coordinates to zero-based column and row indices
  const colIdx = Math.floor(x / cellW - headerOffset);
  const rowIdx = Math.floor(y / cellH - headerOffset);

  // Extra safety check (shouldn’t be needed if bounds check is correct)
  if (colIdx < 0 || rowIdx < 0 || colIdx >= numColumns || rowIdx >= numRows) {
    return null;
  }
  return formatWellCoords({ x: colIdx, y: rowIdx });
}
